import { environment } from '../../environments/environment';

export const restEndpoint = environment.REST_ENDPOINT || 'http://localhost:3000';
